import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BiEdit } from 'react-icons/bi';
import { FcDeleteRow } from 'react-icons/fc';
import { FiUploadCloud, FiSearch, FiFolder, FiTag, FiImage, FiChevronLeft, FiChevronRight, FiX, FiCheck } from 'react-icons/fi';
import { 
  MdCategory, 
  MdBrandingWatermark, 
  MdViewCarousel,
  MdWebAsset,
  MdPhotoLibrary,
  MdSlideshow,
  
} from 'react-icons/md';
import { toast } from 'react-toastify';
import { motion, AnimatePresence } from 'framer-motion';
import { useSelector } from 'react-redux';
function AddCategory() {

  //const weburl = 'http://localhost:8000/images/';
    const weburl = useSelector(state => state.constants.weburl);
  
  const [isClick, setIsClick] = useState(false);
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [imagePreviewEdit, setImagePreviewEdit] = useState('');
  const [editId, setEditId] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const itemsPerPage = 5;
  const [inputProduct, setInputProduct] = useState({
    name: '',
    description: '',
    parent_id: '',
    brand: false,
  });

const typeList = [
  { id: 1, name: 'Category', icon: <MdCategory size={16} />, color: 'bg-blue-50 text-blue-700 border-blue-200' },
  { id: 2, name: 'Left Banner', icon: <MdViewCarousel size={16} />, color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  { id: 3, name: 'Right Banner', icon: <MdWebAsset size={16} />, color: 'bg-purple-50 text-purple-700 border-purple-200' },
  { id: 4, name: 'Bottom Banner', icon: <MdPhotoLibrary size={16} />, color: 'bg-amber-50 text-amber-700 border-amber-200' },
  { id: 5, name: 'Slider', icon: <MdSlideshow size={16} />, color: 'bg-rose-50 text-rose-700 border-rose-200' },
];
  const getTypeStyle = (typeName) => {
    const type = typeList.find(t => t.name === typeName);
    return type || { icon: <MdCategory size={16} />, color: 'bg-gray-50 text-gray-700 border-gray-200' };
  };

  const deleteCategory = (id) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      setIsClick(true);
      axios.delete(`api/delete/category/${id}`).then((res) => {
        setIsClick(false);
        toast.success('Category deleted successfully!');
        fetchCategories();
      }).catch(() => {
        setIsClick(false);
        toast.error('Failed to delete category');
      });
    }
  };

  const handleCheckedBrand = (e) => {
    setInputProduct({ ...inputProduct, brand: e.target.checked });
  };

  const handleInput = (e) => {
    setInputProduct({ ...inputProduct, [e.target.name]: e.target.value });
  };

  const fetchCategories = () => {
    axios.get('api/view/onlinestore/category').then((response) => {
      setCategories(response.data.categories);
    });
  };

  useEffect(() => {
    fetchCategories();
  }, [isClick]);

  const handlePostCategory = (e) => {
    setIsClick(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append('image', images);
    formData.append('id', editId);

    for (const key in inputProduct) {
      formData.append(key, inputProduct[key]);
    }

    if (inputProduct.name === '') {
      toast.error('Category name is required!');
      setIsClick(false);
      return false;
    }

    axios.get('/sanctum/csrf-cookie').then(() => {
      axios
        .post(`/api/post/onlinestore/category`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          setIsClick(false);
          toast.success(editId ? 'Category updated successfully!' : 'Category added successfully!');
          setInputProduct({
            name: '',
            description: '',
            parent_id: '',
            brand: false,
          });
          setEditId('');
          setImagePreview('');
          setImagePreviewEdit('');
          setImages('');
          fetchCategories();
        })
        .catch(() => {
          setIsClick(false);
          toast.error('Failed to save category');
        });
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      toast.error('No file selected!');
      return;
    }
    
    if (file.size > 10 * 1024 * 1024) {
      toast.error('File size should be less than 2MB');
      return;
    }
    
    setImages(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      handleImageChange({ target: { files: [file] } });
    } else {
      toast.error('Please drop an image file');
    }
  };

  const editCategory = (e, id) => {
    e.preventDefault();
    setEditId(id);
    axios.get(`api/edit/category/${id}`).then((res) => {
      const categoryData = res.data.category;
      setInputProduct({
        name: categoryData.name || '',
        brand: categoryData.brand === 'true',
        description: categoryData.description || '',
        parent_id: categoryData.parent_id || '',
      });
      setImagePreviewEdit(categoryData.image || '');
      setImagePreview('');
    });
  };

  const cancelEdit = () => {
    setEditId('');
    setInputProduct({
      name: '',
      description: '',
      parent_id: '',
      brand: false,
    });
    setImagePreview('');
    setImagePreviewEdit('');
    setImages('');
  };

  const filteredCategories = categories.filter(category =>
    category.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredCategories.length / itemsPerPage);
  const paginatedCategories = filteredCategories.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50">
      <div className="max-w-[1600px] mx-auto p-4 md:p-6 lg:p-8">
        {/* Header Section */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-lg">
              <MdCategory className="text-white text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                Category Management
              </h1>
              <p className="text-slate-500 mt-1 text-sm">Manage your product categories, banners and branding</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
          {/* Form Section */}
          <div className="xl:col-span-4">
            <div className="sticky top-6">
              <div className="bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden">
                <div className={`relative overflow-hidden ${editId ? 'bg-gradient-to-r from-amber-500 to-orange-600' : 'bg-gradient-to-r from-blue-600 to-indigo-600'} px-6 py-5`}>
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
                  <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12"></div>
                  <div className="relative z-10">
                    <h2 className="text-xl font-bold text-white">
                      {editId ? '✏️ Edit Category' : '✨ Create New Category'}
                    </h2>
                    <p className="text-white/80 text-sm mt-1">
                      {editId ? 'Update category information' : 'Fill in the details to create a new category'}
                    </p>
                  </div>
                </div>

                <form onSubmit={handlePostCategory} encType="multipart/form-data" className="p-6 space-y-5">
                  <div className="group">
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Category Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={inputProduct.name}
                      onChange={handleInput}
                      className="w-full px-4 py-2.5 border-2 border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 group-hover:border-slate-300"
                      placeholder="Enter category name..."
                    />
                  </div>

                  <div className="flex items-center justify-between p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl border border-purple-100">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-white rounded-lg shadow-sm">
                        <MdBrandingWatermark size={20} className="text-purple-600" />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-slate-700">Brand Category</p>
                        <p className="text-xs text-slate-500">Mark as a brand category</p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        name="brand"
                        checked={inputProduct.brand}
                        onChange={handleCheckedBrand}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                    </label>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Category Image
                    </label>
                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      className={`relative border-2 border-dashed rounded-xl p-6 text-center transition-all duration-200 cursor-pointer
                        ${isDragging 
                          ? 'border-blue-500 bg-blue-50' 
                          : imagePreview || imagePreviewEdit 
                            ? 'border-emerald-400 bg-emerald-50/30' 
                            : 'border-slate-300 hover:border-blue-400 hover:bg-blue-50/50'
                        }`}
                    >
                      <input
                        type="file"
                        name="image"
                        id="image-upload"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      />
                      <label htmlFor="image-upload" className="cursor-pointer block">
                        <div className="flex flex-col items-center gap-2">
                          <div className={`p-3 rounded-full transition-all duration-200 ${isDragging ? 'bg-blue-100' : 'bg-slate-100'}`}>
                            <FiUploadCloud className={`text-3xl ${isDragging ? 'text-blue-600' : 'text-slate-400'}`} />
                          </div>
                          <div>
                            <p className="text-sm font-medium text-slate-700">
                              {isDragging ? 'Drop your image here' : 'Click or drag to upload'}
                            </p>
                            <p className="text-xs text-slate-400 mt-1">PNG, JPG, GIF up to 2MB</p>
                          </div>
                        </div>
                      </label>
                    </div>
                    
                    {(imagePreviewEdit || imagePreview) && (
                      <div className="mt-3 p-3 bg-slate-50 rounded-xl border border-slate-200">
                        <div className="flex items-center justify-between mb-2">
                          <p className="text-xs font-medium text-slate-600">Preview</p>
                          <button
                            type="button"
                            onClick={() => {
                              setImagePreview('');
                              setImagePreviewEdit('');
                              setImages('');
                            }}
                            className="p-1 hover:bg-slate-200 rounded-lg transition-colors"
                          >
                            <FiX size={14} className="text-slate-400" />
                          </button>
                        </div>
                        <img
                          src={imagePreviewEdit ? `${weburl}${imagePreviewEdit}` : imagePreview}
                          alt="Preview"
                          className="w-24 h-24 object-cover rounded-lg border-2 border-white shadow-sm"
                        />
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Parent Category
                    </label>
                    <select
                      name="parent_id"
                      value={inputProduct.parent_id}
                      onChange={handleInput}
                      className="w-full px-4 py-2.5 border-2 border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
                    >
                      <option value="">📁 No Parent (Top Level)</option>
                      {categories
                        .filter(cat => cat.id !== parseInt(editId))
                        .map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Banner Type
                    </label>
                    <select
                      name="description"
                      value={inputProduct.description}
                      onChange={handleInput}
                      className="w-full px-4 py-2.5 border-2 border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
                    >
                      <option value="">🎯 Select Banner Type</option>
                      {typeList.map((item) => (
                        <option key={item.id} value={item.name}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="flex gap-3 pt-2">
                    <button
                      type="submit"
                      disabled={isClick}
                      className={`flex-1 py-2.5 px-4 rounded-xl font-semibold text-white transition-all duration-300 transform
                        ${editId 
                          ? 'bg-gradient-to-r from-amber-500 to-orange-600 hover:shadow-lg hover:scale-[1.02]' 
                          : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:shadow-lg hover:scale-[1.02]'
                        } ${isClick ? 'opacity-70 cursor-not-allowed' : ''}`}
                    >
                      {isClick ? (
                        <span className="flex items-center justify-center gap-2">
                          <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          {editId ? 'Updating...' : 'Adding...'}
                        </span>
                      ) : (
                        <span className="flex items-center justify-center gap-2">
                          <FiCheck size={18} />
                          {editId ? 'Update Category' : 'Add Category'}
                        </span>
                      )}
                    </button>
                    
                    {editId && (
                      <button
                        type="button"
                        onClick={cancelEdit}
                        className="px-6 py-2.5 border-2 border-slate-200 text-slate-700 rounded-xl font-semibold hover:bg-slate-50 hover:border-slate-300 transition-all duration-200"
                      >
                        Cancel
                      </button>
                    )}
                  </div>
                </form>
              </div>

              <div className="mt-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-white rounded-lg shadow-sm">
                    <FiTag className="text-blue-600" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-slate-700">Quick Tips</p>
                    <p className="text-xs text-slate-600 mt-1">• Categories help organize your products</p>
                    <p className="text-xs text-slate-600">• Add images for better visual appeal</p>
                    <p className="text-xs text-slate-600">• Use banners for promotional content</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="xl:col-span-8">
            <div className="bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden">
              <div className="px-6 py-5 border-b border-slate-100 bg-gradient-to-r from-slate-50 to-white">
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                  <div className="flex items-center gap-2">
                    <div className="p-2 bg-blue-100 rounded-lg">
                      <FiFolder className="text-blue-600" />
                    </div>
                    <div>
                      <h2 className="text-lg font-bold text-slate-800">All Categories</h2>
                      <p className="text-xs text-slate-500">{categories.length} total categories</p>
                    </div>
                  </div>
                  
                  <div className="relative">
                    <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
                    <input
                      type="text"
                      placeholder="Search categories..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                      className="pl-10 pr-4 py-2 border-2 border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full sm:w-72 transition-all duration-200"
                    />
                  </div>
                </div>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-slate-50 border-b border-slate-100">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">#</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Image</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Name</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Parent</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Type</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    <AnimatePresence>
                      {paginatedCategories.length > 0 ? (
                        paginatedCategories.map((item, index) => {
                          const typeStyle = getTypeStyle(item.description);
                          return (
                            <motion.tr
                              key={item.id}
                              initial={{ opacity: 0, y: 10 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: -10 }}
                              className="hover:bg-slate-50 transition-colors duration-200 group"
                            >
                              <td className="px-6 py-4 text-sm text-slate-500 font-medium">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td className="px-6 py-4">
                                {item.image ? (
                                  <div className="relative">
                                    <img
                                      src={`${weburl}${item.image}`}
                                      alt={item.name}
                                      className="w-12 h-12 object-cover rounded-xl border-2 border-slate-100 shadow-sm group-hover:scale-105 transition-transform duration-200"
                                    />
                                  </div>
                                ) : (
                                  <div className="w-12 h-12 bg-slate-100 rounded-xl flex items-center justify-center">
                                    <FiImage className="text-slate-400" size={20} />
                                  </div>
                                )}
                              </td>
                              <td className="px-6 py-4">
                                <div className="flex items-center gap-2">
                                  <span className="text-sm font-semibold text-slate-800">{item.name}</span>
                                  {item.brand === 'true' && (
                                    <span className="px-2 py-0.5 text-xs font-medium bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 rounded-full border border-purple-200">
                                      Brand
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <span className="text-sm text-slate-500">
                                  {item.parent_category_name || <span className="text-slate-300">—</span>}
                                </span>
                              </td>
                              <td className="px-6 py-4">
                                <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-lg border ${typeStyle.color}`}>
                                  {typeStyle.icon}
                                  {item.description || 'Category'}
                                </span>
                              </td>
                              <td className="px-6 py-4">
                                <div className="flex gap-1">
                                  <button
                                    onClick={() => editCategory({ preventDefault: () => {} }, item.id)}
                                    className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200 group-hover:scale-105"
                                    title="Edit"
                                  >
                                    <BiEdit size={18} />
                                  </button>
                                  <button
                                    onClick={() => deleteCategory(item.id)}
                                    className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200 group-hover:scale-105"
                                    title="Delete"
                                  >
                                    <FcDeleteRow size={18} />
                                  </button>
                                </div>
                              </td>
                            </motion.tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6" className="px-6 py-16 text-center">
                            <div className="flex flex-col items-center gap-3">
                              <div className="p-4 bg-slate-100 rounded-full">
                                <FiFolder size={32} className="text-slate-400" />
                              </div>
                              <p className="text-slate-500 font-medium">No categories found</p>
                              <p className="text-sm text-slate-400">Try adjusting your search or add a new category</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </AnimatePresence>
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="px-6 py-4 border-t border-slate-100 bg-slate-50/50">
                  <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                    <button
                      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 bg-white border-2 border-slate-200 rounded-xl hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                    >
                      <FiChevronLeft size={16} />
                      Previous
                    </button>
                    
                    <div className="flex gap-1.5">
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`w-9 h-9 text-sm font-semibold rounded-xl transition-all duration-200 ${
                            currentPage === page
                              ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-md'
                              : 'text-slate-700 hover:bg-slate-100'
                          }`}
                        >
                          {page}
                        </button>
                      ))}
                    </div>
                    
                    <button
                      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 bg-white border-2 border-slate-200 rounded-xl hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                    >
                      Next
                      <FiChevronRight size={16} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCategory;